import { Component, Input, computed, inject, signal } from '@angular/core';
import { ButtonIconComponent } from '@tecalisdev/infinity';
import { environment } from '../../../../environments/environment';
import { Permission } from '../../../core/models/role-permissions.models';
import { RolePermissionsService } from '../../../core/services/role-permissions.service';
import { buildCurlGet } from '../../../panel/utils/build-curl.util';
import { ModalCurlRequestComponent } from '../modal-curl-request/modal-curl-request.component';

/**
 * Botón + modal curl GET (permiso VIEW_DEVELOPER_ACTION).
 * Host `display: contents` para no ocupar caja en flex.
 * En `tec-collapse` / `tec-stats` / `tec-item` (proyección `select="tec-button-icon"`),
 * usar `ngProjectAs="tec-button-icon"` para que el icono vaya a la cabecera (p. ej. antes del chevron).
 * En `tec-tile` con `<ng-container actions>` no hace falta `ngProjectAs`.
 */
@Component({
	selector: 'app-developer-curl-button',
	imports: [ButtonIconComponent, ModalCurlRequestComponent],
	styles: [
		`
			:host {
				display: contents;
			}
		`,
	],
	template: `
		@if (showButton && canShow() && path) {
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal()"
			/>
		}
		@if (curlModalOpen()) {
			<app-modal-curl-request [titleKey]="titleKey" [curlText]="curlText()" (closeEvent)="closeCurlModal()" />
		}
	`,
})
export class DeveloperCurlButtonComponent {
	private readonly rolePermissions = inject(RolePermissionsService);

	@Input() path = '';
	@Input() titleKey = 'WORKFLOWS.CURL_MODAL.TITLE';
	/** false: solo modal (apertura programática vía openFor / openCurlModal). */
	@Input() showButton = true;

	public readonly curlModalOpen = signal(false);

	public readonly canShow = computed(() => this.rolePermissions.hasPermission(Permission.VIEW_DEVELOPER_ACTION));

	public readonly curlText = computed(() => (this.path ? buildCurlGet(environment.apiUrl, this.path) : ''));

	public openCurlModal(): void {
		if (!this.path) {
			return;
		}
		this.curlModalOpen.set(true);
	}

	/** Abre el modal con path/title concretos (p. ej. acción de menú). */
	public openFor(titleKey: string, path: string): void {
		if (!path) {
			return;
		}
		this.titleKey = titleKey;
		this.path = path;
		this.curlModalOpen.set(true);
	}

	public closeCurlModal(): void {
		this.curlModalOpen.set(false);
	}
}
